import React from 'react';

export default function ContainedLabel(props) {
        return (
            <label
                color={props.color}
                className={props.className}
                style={props.style}
            >
                {props.textLabel}
            </label>
        );
    }
